export default "__VITE_ASSET__OsiF2nFU__"